import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";

import Wrapper from "../../components/Wrapper";
import Header from "../../components/Header";
import Body from "../../components/Body";
import TopBar from "../../components/TopBar";

import Modal from "@material-ui/core/Modal";

const fontDefault = {
  fontFamily: "thonburiregular",
  fontStyle: "normal"
};

const styles = {
  textTopBar: {
    ...fontDefault,
    color: "#333333",
    fontSize: "18px",
    fontWeight: "bold"
  },
  container: {
    backgroundColor: "#eff0f4"
  },
  list: {
    margin: "0",
    padding: "0",
    listStyle: "none"
  },
  listItem: {
    paddingLeft: "16px"
  },
  listItemContent: {
    borderBottom: "solid 1px #dee1e9",
    padding: "16px 0"
  },
  listItemText: {
    color: "#0e162c",
    ...fontDefault,
    fontFamily: "San Francisco Text",
    fontSize: "16px"
  },
  fieldInput: {
    width: "100%",
    padding: "12px 16px",
    ...fontDefault,
    fontSize: "16px",
    color: "#333333",
    borderRadius: "8px",
    border: "none",
    "&:focus": {
      outlineWidth: "0"
    },
    "&::placeholder": {
      color: "#cdd2de"
    }
  },
  inputContainerInput: {
     border: "1px solid rgb(188 194 210)",
    margin: "16px",
    borderRadius: "8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
  }
};

class Picker extends Component {
  state = {
    filterText: ""
  }

  backButton = () => {
    const { onBack = () => {} } = this.props;
    onBack();
    this.goToTop();
  };

  goToTop = () => {
    const presentation = document.querySelector('[role="presentation"]');
    if (presentation) {
      presentation.scrollTop = 0;
    }
  };

  render() {
    let {
      classes,
      open,
      choices = [],
      onClick = () => {},
      onBack = () => {}
    } = this.props;
    const { filterText } = this.state
    return (
      <Modal
        style={{
          outline: 0,
          overflow: "auto",
          height: "100%",
          display: "block"
        }}
        open={open}
      >
        <Wrapper>
          <Header>
            <TopBar arrowLeft={this.backButton}>
              <Typography align="center" className={classes.textTopBar}>
                เลือกคำนำหน้า
              </Typography>
            </TopBar>
          </Header>
          <Body style={{ backgroundColor: "#eff0f4", overflow: "auto" }}>
            <div className={classes.container}>
              <Grid container>
                <Grid item xs={12}>
                  <div className={classes.inputContainerInput}>
                    <input
                      className={classes.fieldInput}
                      type="text"
                      placeholder="ค้นหา"
                      autoFocus
                      value={filterText}
                      onChange={event => {
                        this.setState({
                          filterText: event.target.value
                        });
                      }}
                    />
                  </div>
                  <ul className={classes.list}>
                    {choices.map(x => {
                      return (
                        <li
                          className={classes.listItem}
                          onClick={() => {
                            onClick(x);
                            onBack();
                            this.goToTop();
                          }}
                        >
                          <div className={classes.listItemContent}>
                            <span className={classes.listItemText}>
                              {x.name}
                            </span>
                          </div>
                        </li>
                      );
                    })}
                  </ul>
                </Grid>
              </Grid>
            </div>
          </Body>
        </Wrapper>
      </Modal>
    );
  }
}
const mapStateToProps = (state, ownProps) => {
  return {};
};

export default connect(mapStateToProps)(withStyles(styles)(Picker));
